/** Closed reasons authored by the solver for each lever assessment. */
export const OBJECTIVE_PACKAGE_LEVER_PARTIAL_REASONS = [
  'none',
  'not_priced',
  'source_lineage_unresolved',
  'no_publishable_value',
  'candidate_only_publishability',
  'non_additive_publishability',
  'non_positive_value',
  'overlap_coverage_incomplete',
  'policy_excluded',
] as const;

export type ObjectivePackageLeverPartialReason =
  (typeof OBJECTIVE_PACKAGE_LEVER_PARTIAL_REASONS)[number];

/** The solver's own de-confliction verdict for one contribution row. */
export const OBJECTIVE_PACKAGE_LEVER_DECONFLICTION_OUTCOMES = [
  'clear',
  'adjusted',
  'held_for_overlap',
  'unresolved',
  'not_priced',
] as const;

export type ObjectivePackageLeverDeconflictionOutcome =
  (typeof OBJECTIVE_PACKAGE_LEVER_DECONFLICTION_OUTCOMES)[number];

/** What a selected member asks of the reader. Unselected rows carry null. */
export const OBJECTIVE_PACKAGE_MEMBER_DISPOSITIONS = [
  'mandate_now',
  'validate',
  'gated',
] as const;

export type ObjectivePackageMemberDisposition =
  (typeof OBJECTIVE_PACKAGE_MEMBER_DISPOSITIONS)[number];
